var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAemLogoLogin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 234,
    height: 87.006,
    viewBox: "0 0 234 87.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6797",
    "data-name": "Rectangle 6797",
    width: 234,
    height: 87.006,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14907",
    "data-name": "Path 14907",
    d: "M41.984,64.821c-.1,0-.207.008-.311.015l0,0a6.9,6.9,0,0,0-4.826,2.5c0,.005-.014,0-.019.006a12.258,12.258,0,0,1-9.183,4.688,11.321,11.321,0,0,1-9.25-3.326l-.011.008a6.931,6.931,0,1,0,.378,9.794c.1-.113.2-.229.3-.348l.011.009a11.311,11.311,0,0,1,8.678-4.617,12.26,12.26,0,0,1,9.757,3.323.01.01,0,0,0,.009,0h.01a6.924,6.924,0,1,0,4.84-12.055Z",
    transform: "translate(-6.747 -64.821)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.099,
    y1: 2.334,
    x2: -0.082,
    y2: 2.334,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#990c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#850c39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14908",
    "data-name": "Path 14908",
    d: "M42.482,16.772a6.91,6.91,0,0,0-4.805,8.776c0,.007-.009.012-.011.017a12.249,12.249,0,0,1-1.044,10.256,11.325,11.325,0,0,1-7.817,5.963V41.8a6.93,6.93,0,1,0,8.432,4.994c-.037-.147-.079-.292-.127-.436l.012,0a11.319,11.319,0,0,1,.836-9.794,12.254,12.254,0,0,1,8.088-6.392c.005,0,.006-.011.011-.014a6.924,6.924,0,1,0-3.575-13.378",
    transform: "translate(-23.593 -16.536)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.148,
    y1: 1.726,
    x2: -0.133,
    y2: 1.726,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90a529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f8f2f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14909",
    "data-name": "Path 14909",
    d: "M49.879,42.514h0a6.918,6.918,0,0,0,3.524,12.357c.005,0,.011.01.016.011A12.238,12.238,0,0,1,62.4,59.926a11.308,11.308,0,0,1,2.36,9.545h.014a6.931,6.931,0,1,0,7.945-5.739c-.151-.024-.3-.044-.457-.058v-.014a11.312,11.312,0,0,1-8.655-4.669,12.249,12.249,0,0,1-2.639-9.961c0-.006-.011-.011-.008-.016a6.921,6.921,0,0,0-11.085-6.5",
    transform: "translate(-47.192 -41.062)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.552,
    y1: 1.256,
    x2: -0.537,
    y2: 1.256,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d99d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0057a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15623",
    "data-name": "Group 15623",
    transform: "translate(-934 -136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14886",
    "data-name": "Path 14886",
    d: "M9.79,106.134V93.94h9.145v2.051h-6.6v3.029h5.192v1.959H12.34v3.1h6.855v2.051Z",
    transform: "translate(931.593 112.899)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15614",
    "data-name": "Group 15614",
    transform: "translate(934 136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15613",
    "data-name": "Group 15613",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14887",
    "data-name": "Path 14887",
    d: "M25.446,107.037V97.8h2.272l.148,2.771-.314-.3a3.667,3.667,0,0,1,.7-1.487,3.058,3.058,0,0,1,1.173-.878,4.108,4.108,0,0,1,3.233.074A2.756,2.756,0,0,1,33.843,99.1a3.686,3.686,0,0,1,.434,1.875v6.06H31.746V101.7a2.266,2.266,0,0,0-.462-1.635,1.646,1.646,0,0,0-1.2-.453,2.2,2.2,0,0,0-1.007.25,1.882,1.882,0,0,0-.794.8,3.063,3.063,0,0,0-.305,1.478v4.9Z",
    transform: "translate(-6.257 -24.004)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14888",
    "data-name": "Path 14888",
    d: "M45.219,107.223a5.343,5.343,0,0,1-2.541-.573,4.017,4.017,0,0,1-1.672-1.643,5.955,5.955,0,0,1,0-5.174,4.05,4.05,0,0,1,1.653-1.644,5.041,5.041,0,0,1,2.43-.573,4.711,4.711,0,0,1,2.384.564,3.814,3.814,0,0,1,1.5,1.533,4.622,4.622,0,0,1,.517,2.208c0,.247-.006.48-.018.7s-.031.419-.056.592H42.041v-1.756H48.3l-1.219.443a2.716,2.716,0,0,0-.526-1.792,1.836,1.836,0,0,0-1.487-.628,2.16,2.16,0,0,0-1.21.333,2.03,2.03,0,0,0-.767.988,4.541,4.541,0,0,0-.259,1.654,3.959,3.959,0,0,0,.287,1.617,2.042,2.042,0,0,0,.813.952,2.8,2.8,0,0,0,2.577,0,2.13,2.13,0,0,0,.776-.868l2.013.775a3.238,3.238,0,0,1-.9,1.238,4.09,4.09,0,0,1-1.423.785,5.655,5.655,0,0,1-1.764.268",
    transform: "translate(-9.938 -24.005)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14889",
    "data-name": "Path 14889",
    d: "M55.777,107.037V97.8h2.2l.166,1.811a3.175,3.175,0,0,1,1.081-1.478,2.954,2.954,0,0,1,1.783-.517,2.691,2.691,0,0,1,.573.056,1.569,1.569,0,0,1,.425.147l-.3,2.125a2.014,2.014,0,0,0-.452-.111,5.349,5.349,0,0,0-.693-.037,2.3,2.3,0,0,0-1.072.268,2.148,2.148,0,0,0-.85.812,2.607,2.607,0,0,0-.333,1.376v4.785Z",
    transform: "translate(-13.716 -24.004)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14890",
    "data-name": "Path 14890",
    d: "M71.455,104.644a3.627,3.627,0,0,1,2.309.647,2.183,2.183,0,0,1,.814,1.811,2.687,2.687,0,0,1-.61,1.783,3.7,3.7,0,0,1-1.709,1.1,7.943,7.943,0,0,1-2.541.37,6.964,6.964,0,0,1-3.482-.665,1.981,1.981,0,0,1-1.1-1.737,1.637,1.637,0,0,1,.582-1.274,3.086,3.086,0,0,1,1.93-.573l-.093.295a2.815,2.815,0,0,1-1.468-.636,1.687,1.687,0,0,1-.508-1.3,1.729,1.729,0,0,1,.656-1.394,3.118,3.118,0,0,1,1.783-.638l1.109.517h-.259a2.01,2.01,0,0,0-1.118.324.773.773,0,0,0-.324.6.644.644,0,0,0,.3.582,1.645,1.645,0,0,0,.878.194Zm-1.7-7.686A6.055,6.055,0,0,1,72,97.338a3.21,3.21,0,0,1,1.459,1.08,2.8,2.8,0,0,1,.508,1.682,2.759,2.759,0,0,1-.508,1.663A3.207,3.207,0,0,1,72,102.843a6.055,6.055,0,0,1-2.245.379,5.06,5.06,0,0,1-3.141-.841,2.728,2.728,0,0,1-1.09-2.282,2.762,2.762,0,0,1,.517-1.682,3.278,3.278,0,0,1,1.46-1.08,6.033,6.033,0,0,1,2.254-.379m-.018,11.658a6.2,6.2,0,0,0,1.579-.167,2.4,2.4,0,0,0,.924-.425.748.748,0,0,0,.3-.573.673.673,0,0,0-.277-.563,1.71,1.71,0,0,0-1-.212H68.147a1.156,1.156,0,0,0-.73.222.726.726,0,0,0-.286.609q0,.517.692.812a4.989,4.989,0,0,0,1.913.3m.018-10.069a1.823,1.823,0,0,0-1.219.406,1.4,1.4,0,0,0-.48,1.127,1.422,1.422,0,0,0,.48,1.136,1.8,1.8,0,0,0,1.219.416,1.762,1.762,0,0,0,1.21-.416,1.437,1.437,0,0,0,.471-1.136,1.412,1.412,0,0,0-.471-1.127,1.789,1.789,0,0,0-1.21-.406m4.73-3.6.3,1.81c-.049,0-.1,0-.157-.008a1.636,1.636,0,0,0-.176-.01,1.873,1.873,0,0,0-1.266.379,1.314,1.314,0,0,0-.434,1.044l-1.035-.425a3.236,3.236,0,0,1,.3-1.376,2.4,2.4,0,0,1,2.272-1.413h.2Z",
    transform: "translate(-16.017 -23.348)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14891",
    "data-name": "Path 14891",
    d: "M88.422,97.86l-3.732,9.811a7.7,7.7,0,0,1-.989,1.995,3.312,3.312,0,0,1-1.256,1.072,3.96,3.96,0,0,1-1.69.333,4.7,4.7,0,0,1-1.321-.176,4.159,4.159,0,0,1-1.044-.452l.535-1.829a2.273,2.273,0,0,0,.739.4,3,3,0,0,0,.887.12,1.731,1.731,0,0,0,.9-.222,1.692,1.692,0,0,0,.638-.886l.314-.795-1.016-2.4L78.556,97.86h2.808L83.12,103.4l.48,1.847.573-1.958,1.682-5.432Z",
    transform: "translate(-19.277 -24.065)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14892",
    "data-name": "Path 14892",
    d: "M105.9,93.695a6.979,6.979,0,0,1,2.919.573,5.729,5.729,0,0,1,2.143,1.7l-1.423,1.644a5.021,5.021,0,0,0-1.654-1.413,4.552,4.552,0,0,0-2.078-.452,3.5,3.5,0,0,0-1.284.2,1.584,1.584,0,0,0-.739.536,1.266,1.266,0,0,0-.231.739,1.079,1.079,0,0,0,.388.841,3.156,3.156,0,0,0,1.33.563l2.272.517a5.18,5.18,0,0,1,2.6,1.21,2.851,2.851,0,0,1,.785,2.078,3.4,3.4,0,0,1-.628,2.059,3.917,3.917,0,0,1-1.756,1.312,6.9,6.9,0,0,1-2.587.452,8.465,8.465,0,0,1-2.337-.3,7.1,7.1,0,0,1-1.894-.84,5.631,5.631,0,0,1-1.386-1.238l1.441-1.718a4.745,4.745,0,0,0,1.053,1.053,5.146,5.146,0,0,0,1.432.73,5.322,5.322,0,0,0,1.69.267,4.1,4.1,0,0,0,1.284-.175,1.7,1.7,0,0,0,.795-.5,1.194,1.194,0,0,0,.268-.786,1.155,1.155,0,0,0-.324-.822,2.316,2.316,0,0,0-1.191-.526l-2.476-.555a7.591,7.591,0,0,1-1.838-.673,2.986,2.986,0,0,1-1.164-1.072,2.953,2.953,0,0,1-.4-1.561,3.4,3.4,0,0,1,.591-1.959,4,4,0,0,1,1.709-1.376,6.463,6.463,0,0,1,2.688-.508",
    transform: "translate(-24.675 -23.04)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14893",
    "data-name": "Path 14893",
    d: "M122.693,101.144a1.656,1.656,0,0,0-.452-1.238,1.634,1.634,0,0,0-1.192-.443,2.088,2.088,0,0,0-1.2.351,2.043,2.043,0,0,0-.757,1.164l-2.162-.665a3.331,3.331,0,0,1,1.376-1.958,4.911,4.911,0,0,1,2.854-.74,5.479,5.479,0,0,1,2.125.379,3.089,3.089,0,0,1,1.413,1.136,3.346,3.346,0,0,1,.508,1.9v3.75q0,.7.665.7a1.849,1.849,0,0,0,.591-.093l-.148,1.571a2.68,2.68,0,0,1-1.2.24,2.926,2.926,0,0,1-1.164-.222,1.783,1.783,0,0,1-.813-.674,2.04,2.04,0,0,1-.3-1.136V105.1l.443-.073a2.082,2.082,0,0,1-.609,1.191,3.346,3.346,0,0,1-1.21.748,4.281,4.281,0,0,1-1.469.259,4.2,4.2,0,0,1-1.626-.287,2.281,2.281,0,0,1-1.053-.841,2.4,2.4,0,0,1-.37-1.367,2.271,2.271,0,0,1,.665-1.69,3.622,3.622,0,0,1,1.9-.9l3.473-.7-.019,1.57-2.217.443a2.782,2.782,0,0,0-.951.342.767.767,0,0,0-.324.693.8.8,0,0,0,.342.7,1.389,1.389,0,0,0,.822.241,3.1,3.1,0,0,0,.758-.093,2.042,2.042,0,0,0,.665-.3,1.37,1.37,0,0,0,.462-.554,1.972,1.972,0,0,0,.167-.85Z",
    transform: "translate(-28.754 -24.004)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14894",
    "data-name": "Path 14894",
    d: "M137.3,97.86h2.623l-3.51,9.238H133.5l-3.51-9.238H132.7l2.272,7.3Z",
    transform: "translate(-31.965 -24.065)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14895",
    "data-name": "Path 14895",
    d: "M146.7,95.211a1.75,1.75,0,0,1-1.182-.342,1.27,1.27,0,0,1-.388-1.007,1.294,1.294,0,0,1,.388-1.026,2.216,2.216,0,0,1,2.364,0,1.294,1.294,0,0,1,.388,1.026,1.27,1.27,0,0,1-.388,1.007,1.751,1.751,0,0,1-1.182.342m1.256,10.567h-2.531V96.541h2.531Z",
    transform: "translate(-35.688 -22.745)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14896",
    "data-name": "Path 14896",
    d: "M152.919,107.037V97.8h2.272l.148,2.771-.314-.3a3.667,3.667,0,0,1,.7-1.487,3.058,3.058,0,0,1,1.173-.878,4.108,4.108,0,0,1,3.233.074,2.756,2.756,0,0,1,1.182,1.118,3.686,3.686,0,0,1,.434,1.875v6.06h-2.531V101.7a2.266,2.266,0,0,0-.462-1.635,1.646,1.646,0,0,0-1.2-.453,2.2,2.2,0,0,0-1.007.25,1.883,1.883,0,0,0-.794.8,3.063,3.063,0,0,0-.305,1.478v4.9Z",
    transform: "translate(-37.604 -24.004)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14897",
    "data-name": "Path 14897",
    d: "M173.791,104.644a3.626,3.626,0,0,1,2.309.647,2.183,2.183,0,0,1,.814,1.811,2.687,2.687,0,0,1-.61,1.783,3.7,3.7,0,0,1-1.709,1.1,7.943,7.943,0,0,1-2.541.37,6.964,6.964,0,0,1-3.482-.665,1.981,1.981,0,0,1-1.1-1.737,1.637,1.637,0,0,1,.582-1.274,3.086,3.086,0,0,1,1.93-.573l-.093.295a2.815,2.815,0,0,1-1.468-.636,1.687,1.687,0,0,1-.508-1.3,1.729,1.729,0,0,1,.656-1.394,3.118,3.118,0,0,1,1.783-.638l1.109.517H171.2a2.01,2.01,0,0,0-1.118.324.773.773,0,0,0-.324.6.644.644,0,0,0,.3.582,1.645,1.645,0,0,0,.878.194Zm-1.7-7.686a6.055,6.055,0,0,1,2.245.379,3.21,3.21,0,0,1,1.459,1.08,2.8,2.8,0,0,1,.508,1.682,2.759,2.759,0,0,1-.508,1.663,3.207,3.207,0,0,1-1.459,1.081,6.055,6.055,0,0,1-2.245.379,5.06,5.06,0,0,1-3.141-.841,2.728,2.728,0,0,1-1.09-2.282,2.762,2.762,0,0,1,.517-1.682,3.278,3.278,0,0,1,1.46-1.08,6.033,6.033,0,0,1,2.254-.379m-.018,11.658a6.2,6.2,0,0,0,1.579-.167,2.4,2.4,0,0,0,.924-.425.748.748,0,0,0,.3-.573.673.673,0,0,0-.277-.563,1.71,1.71,0,0,0-1-.212h-3.123a1.156,1.156,0,0,0-.73.222.726.726,0,0,0-.286.609q0,.517.692.812a4.989,4.989,0,0,0,1.913.3m.018-10.069a1.823,1.823,0,0,0-1.219.406,1.4,1.4,0,0,0-.48,1.127,1.422,1.422,0,0,0,.48,1.136,1.8,1.8,0,0,0,1.219.416,1.762,1.762,0,0,0,1.21-.416,1.437,1.437,0,0,0,.471-1.136,1.412,1.412,0,0,0-.471-1.127,1.789,1.789,0,0,0-1.21-.406m4.73-3.6.3,1.81c-.049,0-.1,0-.157-.008a1.636,1.636,0,0,0-.176-.01,1.873,1.873,0,0,0-1.266.379,1.314,1.314,0,0,0-.434,1.044l-1.035-.425a3.236,3.236,0,0,1,.3-1.376,2.4,2.4,0,0,1,2.272-1.413h.2Z",
    transform: "translate(-41.183 -23.348)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14898",
    "data-name": "Path 14898",
    d: "M194.935,93.695a6.979,6.979,0,0,1,2.919.573,5.729,5.729,0,0,1,2.143,1.7l-1.423,1.644a5.026,5.026,0,0,0-1.653-1.413,4.557,4.557,0,0,0-2.079-.452,3.493,3.493,0,0,0-1.283.2,1.587,1.587,0,0,0-.74.536,1.266,1.266,0,0,0-.23.739,1.08,1.08,0,0,0,.387.841,3.165,3.165,0,0,0,1.331.563l2.273.517a5.174,5.174,0,0,1,2.595,1.21,2.848,2.848,0,0,1,.786,2.078,3.4,3.4,0,0,1-.628,2.059,3.921,3.921,0,0,1-1.756,1.312,6.9,6.9,0,0,1-2.587.452,8.466,8.466,0,0,1-2.337-.3,7.092,7.092,0,0,1-1.894-.84,5.631,5.631,0,0,1-1.386-1.238l1.441-1.718a4.745,4.745,0,0,0,1.053,1.053,5.152,5.152,0,0,0,1.431.73,5.33,5.33,0,0,0,1.691.267,4.1,4.1,0,0,0,1.284-.175,1.7,1.7,0,0,0,.794-.5,1.191,1.191,0,0,0,.268-.786,1.155,1.155,0,0,0-.324-.822,2.316,2.316,0,0,0-1.191-.526l-2.476-.555a7.591,7.591,0,0,1-1.838-.673,2.8,2.8,0,0,1-1.561-2.633,3.4,3.4,0,0,1,.591-1.959,4,4,0,0,1,1.709-1.376,6.463,6.463,0,0,1,2.688-.508",
    transform: "translate(-46.569 -23.04)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14899",
    "data-name": "Path 14899",
    d: "M207.874,95.211a1.752,1.752,0,0,1-1.182-.342,1.272,1.272,0,0,1-.388-1.007,1.3,1.3,0,0,1,.388-1.026,2.217,2.217,0,0,1,2.365,0,1.3,1.3,0,0,1,.388,1.026,1.274,1.274,0,0,1-.388,1.007,1.756,1.756,0,0,1-1.183.342m1.256,10.567H206.6V96.541h2.531Z",
    transform: "translate(-50.732 -22.745)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14900",
    "data-name": "Path 14900",
    d: "M214.1,107.037V97.8h2.273l.093,1.663a3.186,3.186,0,0,1,1.265-1.385,3.7,3.7,0,0,1,3.584,0,2.889,2.889,0,0,1,1.21,1.367,2.957,2.957,0,0,1,.795-1.017,3.526,3.526,0,0,1,1.109-.61,3.9,3.9,0,0,1,1.237-.2,3.69,3.69,0,0,1,1.654.37,2.83,2.83,0,0,1,1.191,1.109,3.62,3.62,0,0,1,.443,1.884v6.06h-2.531v-5.561a1.941,1.941,0,0,0-.443-1.441,1.588,1.588,0,0,0-1.146-.425,1.981,1.981,0,0,0-1.025.278,1.886,1.886,0,0,0-.738.822,3.054,3.054,0,0,0-.268,1.358v4.969h-2.531v-5.561a1.916,1.916,0,0,0-.453-1.441,1.618,1.618,0,0,0-1.155-.425,1.965,1.965,0,0,0-.952.259,1.99,1.99,0,0,0-.776.813,3.023,3.023,0,0,0-.305,1.46v4.9Z",
    transform: "translate(-52.648 -24.004)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14901",
    "data-name": "Path 14901",
    d: "M240.935,107.283a4,4,0,0,1-1.663-.332,2.573,2.573,0,0,1-1.173-1.063,3.659,3.659,0,0,1-.434-1.894V97.861H240.2v5.524a2,2,0,0,0,.443,1.487,1.8,1.8,0,0,0,1.275.416,2.133,2.133,0,0,0,.758-.139,1.778,1.778,0,0,0,.656-.434,2.069,2.069,0,0,0,.452-.767,3.344,3.344,0,0,0,.167-1.118v-4.97h2.531V107.1h-2.255l-.092-1.607a3.021,3.021,0,0,1-1.265,1.358,4.015,4.015,0,0,1-1.93.434",
    transform: "translate(-58.444 -24.065)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14902",
    "data-name": "Path 14902",
    d: "M255.851,92.5v10.439a1.415,1.415,0,0,0,.222.9.928.928,0,0,0,.739.259,2.438,2.438,0,0,0,.517-.046c.136-.031.308-.077.517-.139l-.221,1.663a2.651,2.651,0,0,1-.786.287,4.46,4.46,0,0,1-.934.1,2.6,2.6,0,0,1-1.967-.655,2.982,2.982,0,0,1-.619-2.1V92.5Z",
    transform: "translate(-62.293 -22.745)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14903",
    "data-name": "Path 14903",
    d: "M266.9,101.144a1.656,1.656,0,0,0-.452-1.238,1.632,1.632,0,0,0-1.191-.443,2.088,2.088,0,0,0-1.2.351,2.04,2.04,0,0,0-.758,1.164l-2.162-.665a3.332,3.332,0,0,1,1.377-1.958,4.911,4.911,0,0,1,2.854-.74,5.472,5.472,0,0,1,2.124.379,3.085,3.085,0,0,1,1.413,1.136,3.346,3.346,0,0,1,.508,1.9v3.75q0,.7.666.7a1.848,1.848,0,0,0,.59-.093l-.147,1.571a2.679,2.679,0,0,1-1.2.24,2.928,2.928,0,0,1-1.164-.222,1.785,1.785,0,0,1-.812-.674,2.034,2.034,0,0,1-.3-1.136V105.1l.443-.073a2.078,2.078,0,0,1-.609,1.191,3.333,3.333,0,0,1-1.21.748,4.277,4.277,0,0,1-1.468.259,4.192,4.192,0,0,1-1.626-.287,2.28,2.28,0,0,1-1.053-.841,2.408,2.408,0,0,1-.37-1.367,2.271,2.271,0,0,1,.665-1.69,3.62,3.62,0,0,1,1.9-.9l3.474-.7-.019,1.57-2.217.443a2.787,2.787,0,0,0-.952.342.767.767,0,0,0-.323.693.8.8,0,0,0,.342.7,1.393,1.393,0,0,0,.823.241,3.1,3.1,0,0,0,.757-.093,2.028,2.028,0,0,0,.665-.3,1.366,1.366,0,0,0,.462-.554,1.973,1.973,0,0,0,.166-.85Z",
    transform: "translate(-64.215 -24.004)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14904",
    "data-name": "Path 14904",
    d: "M281.773,98.823h-7.186V96.938h7.186Zm-2.956-4.711v9.053a1.236,1.236,0,0,0,.342.97,1.349,1.349,0,0,0,.933.3,2.19,2.19,0,0,0,.822-.138,2.222,2.222,0,0,0,.62-.379l.406,1.681a3.356,3.356,0,0,1-1.109.554,4.8,4.8,0,0,1-1.4.2,4.475,4.475,0,0,1-1.635-.277,2.264,2.264,0,0,1-1.109-.887,2.937,2.937,0,0,1-.4-1.626V94.814Z",
    transform: "translate(-67.523 -23.143)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14905",
    "data-name": "Path 14905",
    d: "M290.928,97.615a5.122,5.122,0,0,1,2.467.573,4.121,4.121,0,0,1,1.664,1.644,5.86,5.86,0,0,1,0,5.164,4.1,4.1,0,0,1-1.664,1.653,5.574,5.574,0,0,1-4.923,0A4.078,4.078,0,0,1,286.8,105a5.86,5.86,0,0,1,0-5.164,4.1,4.1,0,0,1,1.673-1.644,5.133,5.133,0,0,1,2.457-.573m0,1.884a2.12,2.12,0,0,0-1.191.324,2.013,2.013,0,0,0-.748.971,5.236,5.236,0,0,0,0,3.251,2,2,0,0,0,.748.97,2.108,2.108,0,0,0,1.191.324,2.075,2.075,0,0,0,1.173-.324,2.019,2.019,0,0,0,.749-.97,5.237,5.237,0,0,0,0-3.251,2.028,2.028,0,0,0-.749-.971,2.087,2.087,0,0,0-1.173-.324",
    transform: "translate(-70.379 -24.004)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14906",
    "data-name": "Path 14906",
    d: "M302.05,107.037V97.8h2.2l.167,1.811a3.174,3.174,0,0,1,1.08-1.478,2.955,2.955,0,0,1,1.783-.517,2.684,2.684,0,0,1,.572.056,1.575,1.575,0,0,1,.425.147l-.3,2.125a2.025,2.025,0,0,0-.452-.111,5.357,5.357,0,0,0-.693-.037,2.3,2.3,0,0,0-1.072.268,2.148,2.148,0,0,0-.85.812,2.607,2.607,0,0,0-.333,1.376v4.785Z",
    transform: "translate(-74.277 -24.004)",
    fill: "#1a1818"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15616",
    "data-name": "Group 15616",
    transform: "translate(939.088 184.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15615",
    "data-name": "Group 15615",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6798",
    "data-name": "Rectangle 6798",
    width: 43.884,
    height: 16.665,
    transform: "translate(-0.755 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15618",
    "data-name": "Group 15618",
    transform: "translate(951.791 148.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15617",
    "data-name": "Group 15617",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6799",
    "data-name": "Rectangle 6799",
    width: 48.742,
    height: 44.57,
    transform: "translate(-17.451 30.459) rotate(-61.236)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15620",
    "data-name": "Group 15620",
    transform: "translate(969.587 166.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15619",
    "data-name": "Group 15619",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6800",
    "data-name": "Rectangle 6800",
    width: 48.541,
    height: 49.291,
    transform: "matrix(0.791, -0.612, 0.612, 0.791, -18.782, 13.842)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15622",
    "data-name": "Group 15622",
    transform: "translate(934 136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15621",
    "data-name": "Group 15621",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14910",
    "data-name": "Path 14910",
    d: "M111.531,65.982a18.739,18.739,0,0,1-9.441-2.353,15.941,15.941,0,0,1-6.425-6.937,24.746,24.746,0,0,1-2.292-11.161,23.427,23.427,0,0,1,2.413-11.04,16.816,16.816,0,0,1,6.907-7.058A21.624,21.624,0,0,1,113.28,24.96q6.755,0,10.919,2.443a15.934,15.934,0,0,1,6.455,7.752l-9.592,3.8a7.415,7.415,0,0,0-2.775-4.464A8.449,8.449,0,0,0,113.34,33.1a8.877,8.877,0,0,0-5.067,1.418,8.686,8.686,0,0,0-3.2,4.163,18.543,18.543,0,0,0-1.086,6.787,19.363,19.363,0,0,0,1.116,7.058,8.272,8.272,0,0,0,3.318,4.193,10.225,10.225,0,0,0,5.46,1.358,11.376,11.376,0,0,0,3.2-.423,7.814,7.814,0,0,0,2.534-1.237,5.586,5.586,0,0,0,1.689-2.05,6.623,6.623,0,0,0,.6-2.927v-.6H112.8V43.9h17.917V65.379h-7.058l-.784-9.351,1.689,1.448a11.329,11.329,0,0,1-4.555,6.3,14.947,14.947,0,0,1-8.476,2.2",
    transform: "translate(-22.961 -6.138)",
    fill: "#141212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14911",
    "data-name": "Path 14911",
    d: "M183.393,53.977a15.934,15.934,0,0,1-3.68,6.847,15.085,15.085,0,0,1-6.033,3.921,23.049,23.049,0,0,1-7.722,1.237,21.181,21.181,0,0,1-10.437-2.443,16.4,16.4,0,0,1-6.757-7.028,23.925,23.925,0,0,1-2.353-11.04,23.933,23.933,0,0,1,2.353-11.04,16.408,16.408,0,0,1,6.757-7.028A21.06,21.06,0,0,1,165.9,24.96a23.915,23.915,0,0,1,7.662,1.176,14.977,14.977,0,0,1,5.912,3.589,13.609,13.609,0,0,1,3.439,6.214l-9.109,3.68q-.846-3.74-2.745-5.128a7.924,7.924,0,0,0-4.8-1.388,8.657,8.657,0,0,0-4.917,1.388,8.749,8.749,0,0,0-3.2,4.132,18.254,18.254,0,0,0-1.116,6.847,19.754,19.754,0,0,0,1.026,6.817,8.235,8.235,0,0,0,3.107,4.163,9.089,9.089,0,0,0,5.158,1.388,7.678,7.678,0,0,0,4.917-1.6,8.245,8.245,0,0,0,2.745-4.917Z",
    transform: "translate(-36.004 -6.138)",
    fill: "#141212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14912",
    "data-name": "Path 14912",
    d: "M199.931,65.575V25.759h31.008v8.024H210.307v8.084h16.409v7.541H210.307v8.144h21.416v8.024Z",
    transform: "translate(-49.165 -6.334)",
    fill: "#141212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14913",
    "data-name": "Path 14913",
    d: "M293.3,25.759V65.575h-9.17V47.3l.3-12.247h-.121l-9.833,30.526h-8.385l-9.833-30.526h-.121l.3,12.247V65.575h-9.23V25.759h14.78l6.274,20.27,2.232,8.446h.121l2.292-8.386,6.214-20.33Z",
    transform: "translate(-60.791 -6.334)",
    fill: "#141212"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAemLogoLogin);
export default __webpack_public_path__ + "static/media/AEM-LogoLogin.3f0dbb2c589522869192e973864a723e.svg";
export { ForwardRef as ReactComponent };